import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router'
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

@Injectable({
    providedIn: 'root'
})
export class S3Service {
    baseUrl = environment.baseUrl;
    test: any;
    FOLDER = "temp";
    file: any;
    video: any;
    pdf: any;
    attachemnetName: any;
    // s3IdentityPool = 'ap-south-1:482f5ad2-7d3c-4db0-ac55-1b178db31a7f';
    // s3Accesskey = 'AKIAR6SRPD5YQJNVORPY';
    // s3SecretKey = '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';
    // s3Region = 'AP_SOUTH_1';
    // s3Bucket = 'unsub-prod';

    s3IdentityPool = environment.s3IdentityPool;
    s3Accesskey = environment.s3Accesskey;
    s3SecretKey = environment.s3SecretKey;
    s3Region = environment.s3Region;
    s3Bucket = environment.s3Bucket;

    constructor(private _httpClient: HttpClient,
        private router: Router, ) {

        this.test = 'test'
    }


    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {

            Promise.all([
                this.uploadfile(this.file),
                this.uploadVideo(this.video),
                this.uploadPdf(this.pdf)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    uploadfile(file): Promise<any> {
        return new Promise((resolve) => {
            const contentType = file.type;
            AWS.config.region = this.s3Region;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: this.s3IdentityPool,
            });
            const bucket = new S3(
                {
                    accessKeyId: this.s3Accesskey,
                    secretAccessKey: this.s3SecretKey,
                    region: this.s3Region,
                }
            );
            const str = contentType
            const res = str.split("/");
            const file_name = res[res.length - 1];
            const objKey = 'temp_folder/' + (Math.floor(Math.random() * 1000000000) + 1) + '_' + Math.round((new Date()).getTime() / 1000) + "." + file_name;

            const params = {
                Bucket: this.s3Bucket,
                Key: objKey,
                Body: file,
                ACL: 'bucket-owner-full-control',
                ContentType: contentType,

            };
            bucket.upload(params, function (err, data) {
                console.log('params', params)
                if (err) {
                    console.log('There was an error uploading your file: ', err);
                    return false;
                }

                resolve(data);
            })

        });
    }

    uploadVideo(video): Promise<any> {
        return new Promise((resolve) => {
            const contentType = video.type;
            AWS.config.region = this.s3Region;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: this.s3IdentityPool,
            });
            const bucket = new S3(
                {
                    accessKeyId: this.s3Accesskey,
                    secretAccessKey: this.s3SecretKey,
                    region: this.s3Region,

                }
            );
            const str2 = contentType
            const res2 = str2.split("/");
            const file_name2 = res2[res2.length - 1];
            const objKey = 'temp_folder/' + (Math.floor(Math.random() * 1000000000) + 1) + '_' + Math.round((new Date()).getTime() / 1000) + "." + file_name2;
            const params = {
                Bucket: this.s3Bucket,
                Key: objKey,
                Body: video,
                ACL: 'bucket-owner-full-control',
                ContentType: contentType,

            };
            bucket.upload(params, function (err, data) {
                console.log('params', params)
                if (err) {
                    console.log('There was an error uploading your file: ', err);
                    return false;
                }
                resolve(data);
            })

        });
    }



    uploadPdf(pdf): Promise<any> {
        console.log('pdf', pdf)
        this.attachemnetName = pdf.name
        return new Promise((resolve) => {
            const contentType = pdf.type;
            AWS.config.region = this.s3Region;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: this.s3IdentityPool,
            });
            const bucket = new S3(
                {
                    accessKeyId: this.s3Accesskey,
                    secretAccessKey: this.s3SecretKey,
                    region: this.s3Region,

                }
            );
            const str3 = contentType
            const res3 = str3.split("/");
            const file_name3 = res3[res3.length - 1];
            const objKey = 'temp_folder/' + (Math.floor(Math.random() * 1000000000) + 1) + '_' + Math.round((new Date()).getTime() / 1000) + '.' + file_name3;
            const params = {
                Bucket: this.s3Bucket,
                Key: objKey,
                Body: pdf,
                ACL: 'bucket-owner-full-control',
                ContentType: contentType,

            };
            bucket.upload(params, function (err, data) {
                console.log('params', params)
                if (err) {
                    console.log('There was an error uploading your file: ', err);
                    return false;
                }
                resolve(data);
            })
        });
    }
}
